module.exports = __webpack_public_path__ + "img/svg/background-wetris.698af0220eab34a50294c9e252c4ad3a.svg";